module.exports = __webpack_public_path__ + "static/media/icon-folder.c6257a23.svg";